// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"3cd73102","453":"670e15c7","927":"5bea2ae7"}[chunkId] + ".chunk.js";
};